/**
 * Canonical color surface for Operations Planning and all forest-visualization
 * components. Import from here instead of defining ad-hoc hex constants.
 *
 * Colors resolve from CSS tokens (--fm-*) via components/ui/charts/palette.ts.
 */

import {
  paletteAssortment,
  paletteOperation,
  paletteSpecies,
  parseSpeciesCode,
} from '@/components/ui/charts/palette';

/**
 * Species colour from a served species code (number or numeric string). Names
 * are refused by the palette, naming the value.
 */
export const resolveSpeciesColor = (code: number | string): string =>
  paletteSpecies(parseSpeciesCode(code));

// Operation type colors — canonical palette used by OpsMap, OpsRow, legend

export const OPERATION_COLORS = {
  thinning:    paletteOperation('thinning'),
  'seed-tree': paletteOperation('seed-tree'),
  clearcut:    paletteOperation('clearcut'),
  planting:    paletteOperation('planting'),
  tending:     paletteOperation('tending'),
} as const;

export type OperationColorKey = keyof typeof OPERATION_COLORS;

export const UNTOUCHED_COLOR = paletteOperation('untouched');

// Assortment colors — canonical palette for sawlog / pulpwood legend items

export const SAWLOG_COLOR   = paletteAssortment('sawlog');
export const PULPWOOD_COLOR = paletteAssortment('pulpwood');
export const ENERGY_COLOR   = paletteAssortment('energy');
